import {NEXT_PUBLIC_BASE_URL} from "./copyright";

export const DEFAULT_SHARE_IMAGE = `${NEXT_PUBLIC_BASE_URL}/icons/media-logo.svg`;
export const ORGANIZATION_LOGO = `${NEXT_PUBLIC_BASE_URL}/icons/media-logo.svg`;

export const ARTICLE_OG_TYPES = new Set([
  "news",
  "article",
  "podcast",
  "quiz",
  "cards",
  "horoscope",
]);

export function normalizeOgType(type) {
  if (!type || type === "website") return "website";
  if (type === "article" || ARTICLE_OG_TYPES.has(type)) return "article";
  return "website";
}

export function resolveShareImage(image) {
  if (!image) return DEFAULT_SHARE_IMAGE;
  if (typeof image === "string") return image || DEFAULT_SHARE_IMAGE;
  return image.default || image.fb || image.vk || image.tw || DEFAULT_SHARE_IMAGE;
}
